import {
  Dialog,
  Box,
  DialogTitle,
  DialogContent,
  ThemeProvider,
  Button,
  DialogActions,
  DialogContentText,
} from '@mui/material';
import { ClearIcon } from '@mui/x-date-pickers-pro';
import { customDialogRegroupParcelsTheme } from 'assets/styles/themes/Dialog/generic_dialog_regroup_parcel';
import { customButtonTheme } from 'assets/styles/themes/generic_button_mui';
import Clear from '@mui/icons-material/Clear';
import { useTranslation } from 'react-i18next';

type ProcedureOvertakeModalParams = {
  modalOvertakeProcedure: boolean;
  setModalProcedure: (value: boolean) => void;
  setModalOvertakeProcedure: (value: boolean) => void;
  setWillOvertakeProcedure: (value: boolean) => void;
};
const ProcedureOvertakeModal = ({
  modalOvertakeProcedure,
  setModalProcedure,
  setModalOvertakeProcedure,
  setWillOvertakeProcedure,
}: ProcedureOvertakeModalParams) => {
  const { t } = useTranslation();
  return (
    <ThemeProvider theme={customDialogRegroupParcelsTheme}>
      <Dialog
        maxWidth="lg"
        fullWidth
        open={modalOvertakeProcedure}
        onClose={() => setModalOvertakeProcedure(false)}
      >
        <Box>
          <DialogTitle>{t('dialog.overtakeProcedureTitle')}</DialogTitle>
          <ClearIcon onClick={() => setModalOvertakeProcedure(false)} />
        </Box>
        <DialogContent>
          <DialogContentText className="whiteSpacePreWrap">
            {t('dialog.overtakeProcedureMessage')}
          </DialogContentText>
          <br />
        </DialogContent>
        <DialogActions>
          <ThemeProvider theme={customButtonTheme}>
            <Button
              id="inputConfirmOvertake"
              onClick={() => {
                setModalOvertakeProcedure(false);
                setModalProcedure(true);
                setWillOvertakeProcedure(true);
              }}
            >
              {t('button.takeControl')}
            </Button>
          </ThemeProvider>
          <Button
            id="inputConfirmOvertake"
            onClick={() => {
              setModalOvertakeProcedure(false);
            }}
          >
            {t('common.cancel')}
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
};

export default ProcedureOvertakeModal;
